(function(){
  // ======= Swatches & ATC =======
  function setSelected(pill, group){
    group.querySelectorAll('button').forEach(b=>{
      b.classList.remove('is-selected'); b.setAttribute('aria-pressed','false');
    });
    pill.classList.add('is-selected'); pill.setAttribute('aria-pressed','true');
  }
  function getProductData(card){
    const el = card.querySelector('script.product-json'); if (!el) return null;
    try { return JSON.parse(el.textContent); } catch { return null; }
  }
  function updateVariantId(card, requireSize){
    const color = card.querySelector('.color-pill.is-selected')?.dataset.color;
    const size  = card.querySelector('.size-pill.is-selected')?.dataset.size;
    const data  = getProductData(card); if (!data) return null;

    let match = null;
    for (const v of data.variants){
      const okColor = !color || v.options.includes(color);
      const okSize  = !size  || v.options.includes(size);
      if (okColor && okSize && v.available){ match = v; break; }
    }

    const form = card.querySelector('.quick-add-form');
    const idInput = form.querySelector('input[name="id"]');
    const btn = form.querySelector('.quick-add-btn');
    const sizeGroup = card.querySelector('[data-size-picker]');
    const sizeError = card.querySelector('.size-error');

    if (match){ idInput.value = match.id; btn.disabled = false; }
    else { idInput.value = ''; btn.disabled = true; }

    if (requireSize && sizeGroup){
      const hasSize = !!sizeGroup.querySelector('.size-pill.is-selected');
      if (!hasSize && sizeError) sizeError.hidden = false; else if (sizeError) sizeError.hidden = true;
    }
    return match;
  }

  document.addEventListener('click', (e)=>{
    const pill = e.target.closest('.color-pill, .size-pill'); if (!pill || pill.disabled) return;
    const group = pill.closest('[data-color-picker],[data-size-picker]'); const card = pill.closest('.grid-product__bottom');
    if (!group || !card) return;
    setSelected(pill, group);
    updateVariantId(card, false);
  });

  document.addEventListener('submit', async (e)=>{
    const form = e.target.closest('.quick-add-form'); if (!form) return;
    e.preventDefault();
    const card = form.closest('.grid-product__bottom');
    const sizeExists = !!card.querySelector('[data-size-picker]');
    const match = updateVariantId(card, sizeExists);

    if (sizeExists && !card.querySelector('.size-pill.is-selected')) {
      const err = card.querySelector('.size-error'); if (err) err.hidden = false;
      const first = card.querySelector('.size-pill:not([disabled])'); if (first) first.focus();
      return;
    }
    if (!match) return;

    const btn = form.querySelector('.quick-add-btn');
    const original = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
    try {
      const data = new FormData(form);
      const resp = await fetch('/cart/add.js', { method:'POST', body:data, headers:{'X-Requested-With':'XMLHttpRequest'} });
      if (!resp.ok) throw new Error();
      const cartResp = await fetch('/cart.js', { headers:{'X-Requested-With':'XMLHttpRequest'} });
      const cart = await cartResp.json();
      document.querySelectorAll('.cart-count, .header-cart-count, [data-cart-count]').forEach(el=>{ el.textContent = cart.item_count; });
      btn.textContent = 'Added ✓'; setTimeout(()=>{ btn.textContent = original; btn.disabled = false; }, 1200);
    } catch(err) {
      console.error(err); btn.textContent = 'Try again'; setTimeout(()=>{ btn.textContent = original; btn.disabled = false; }, 1500);
    }
  });

  // ======= Slider (arrow + swipe) =======
  function sliderState(root){
    const slides = root.querySelector('[data-slides]');
    const total = slides ? slides.children.length : 0;
    const index = parseInt(root.getAttribute('data-index') || '0', 10);
    return {root, slides, total, index};
  }
  function go(root, i){
    const st = sliderState(root);
    if (!st.slides || st.total <= 1) return;
    const next = (i + st.total) % st.total;
    root.setAttribute('data-index', String(next));
    st.slides.style.transform = 'translateX(' + (-next*100) + '%)';
  }

  // Arrow clicks (delegated)
  document.addEventListener('click', (e)=>{
    const prevBtn = e.target.closest('[data-prev]'); const nextBtn = e.target.closest('[data-next]');
    if (!prevBtn && !nextBtn) return;
    const root = (prevBtn || nextBtn).closest('[data-slider]'); if (!root) return;
    const st = sliderState(root); if (st.total <= 1) return;
    if (prevBtn) go(root, st.index - 1);
    if (nextBtn) go(root, st.index + 1);
  });

  // Swipe gestures (per slider)
  document.querySelectorAll('[data-slider]').forEach(root=>{
    const slides = root.querySelector('[data-slides]'); if (!slides) return;
    let startX=0, dx=0, drag=false;
    slides.addEventListener('pointerdown', (e)=>{ drag=true; startX=e.clientX; slides.style.transition='none'; });
    window.addEventListener('pointermove', (e)=>{ if(!drag) return; dx=e.clientX-startX; const st=sliderState(root); slides.style.transform='translateX(calc('+(-st.index*100)+'% + '+dx+'px))'; });
    window.addEventListener('pointerup', ()=>{ if(!drag) return; slides.style.transition=''; const st=sliderState(root); if(Math.abs(dx)>40){ if(dx<0) go(root, st.index+1); else go(root, st.index-1); } else go(root, st.index); drag=false; dx=0; });
  });
})();